module.exports = __webpack_public_path__ + "img/stepvan_parked.b1cb5795.svg";